import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=778b54a6&scoped=true"
import script from "./SelectCategory.vue?vue&type=script&lang=js"
export * from "./SelectCategory.vue?vue&type=script&lang=js"
import style0 from "./SelectCategory.vue?vue&type=style&index=0&id=778b54a6&prod&lang=scss&scoped=true"
import style1 from "./SelectCategory.vue?vue&type=style&index=1&id=778b54a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b54a6",
  null
  
)

export default component.exports